
export const UsersDate = [
    {id:1 , name:'Abbas' , phone:"09178272816"},
    {id:2 , name:'Alireza' , phone:"09121221202"},
    {id:3 , name:'Reza' , phone:"09108002435"},
]